/**
 * @module cercaliagl/control/Clean
 */
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import VControlButton from '../view/VControlButton';

/**
 * @classdesc
 * Provides a button that clean up the painted elements on the map related to the API's own controls.
 * @extends {Control}
 * @api
 */
class Clean extends Control {
  /**
   * @constructor
   */
  constructor() {
    const controlButton = new VControlButton('clean');
    const element = controlButton.getElement();

    super({
      element,
      className: 'cercaliagl.control.Clean',
      name: MapControls.CLEAN,
    });

    /**
     * @private
     * @type {VControlButton}
     */
    this.controlButton_ = controlButton;

    /**
     * @private
     * @type {HTMLElement}
     */
    this.element_ = element;

    this.initialize_();
  }

  /**
   * @private
   */
  initialize_() {
    this.controlButton_.setTooltip(i18n('tooltipClean'));
    this.element_.addEventListener('click', this.handleClick_.bind(this));
  }

  /**
   * Force clean. Call handle click event function.
   * @api
   */
  clean() {
    this.handleClick_();
  }

  /**
   * @private
   */
  handleClick_() {
    this.viewInterface_.closePopups();
    const addressControl = this.viewInterface_.getAddressControl();
    if (addressControl) {
      addressControl.clean();
    }
    const navbarControl = this.viewInterface_.getNavBarControl();
    if (navbarControl) {
      navbarControl.clear();
    }
    const map = this.getCercaliaMap();
    const mapDistance = map.getMapDistance();
    if (mapDistance) {
      mapDistance.clean();
    }
  }
}

export default Clean;
